import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getPVReportById} from '../actions/property_visit_action';

export default function PropertyVisitContainer(component) {
    return connect(mapStateToProps, mapDispatchToProps)(component);
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({getPVReportById}, dispatch);
}

function mapStateToProps(state) {
    return {
        data: state.pv.data,
        isFetching: state.pv.isFetching
    };
}



// WEBPACK FOOTER //
// ./src/containers/property_visit_container.js